export const API_BASE_URL = `${process.env['API_SPONSOR_URL']}/api/${process.env['API_SPONSOR_VERSION']}`
export const endpoints = {
  login: 'login', // GET
  signup: 'register', // POST
  logout: 'logout', // DELETE
  user: {
    getUser: 'user/me', // GET
    updateUser: 'user/update', // POST
    upload: 'user/upload', // PUT
    getRegistryFile: 'user/registry', // GET
    updateUserEmail: 'user', // PUT
  },
  location: {
    getAllLocations: 'locations', // GET
  },
  confirmUser: 'confirmation', // GET
  resendConfirmUserEmail: 'confirmation', // POST
  confirmInvitation: 'invitation', // PUT
  getUserFromToken: 'invitation/accept', // GET
  forgotPassword: 'password/forgot', // POST
  resetPassword: 'password/reset', // POST
  sponsorRequest: {
    getAllSponsorRequests: 'user/sponsor_requests', // GET
    getSponsorRequest: {
      path: 'user/sponsor_requests/:sponsor_request_id', // GET
      makeUrl: (sponsor_request_id: string): string =>
        `user/sponsor_requests/${sponsor_request_id}`, // GET
    },
    setStatusSponsorRequest: {
      path: 'user/sponsor_requests/:sponsor_request_id/set_status', // PUT
      makeUrl: (sponsor_request_id: string): string =>
        `user/sponsor_requests/${sponsor_request_id}/set_status`, // PUT
    },
    createSponsorRequest: 'user/sponsor_requests', // POST
    updateSponsorRequest: {
      path: 'user/sponsor_requests/:sponsor_request_id', // PUT
      makeUrl: (sponsor_request_id: string): string =>
        `user/sponsor_requests/${sponsor_request_id}`, // PUT
    },
    uploadSponsorRequestFiles: {
      path: 'user/sponsor_requests/:sponsor_request_id/upload', // PUT
      makeUrl: (sponsor_request_id: string): string =>
        `user/sponsor_requests/${sponsor_request_id}/upload`, // PUT
    },
    uploadSignedOutcomeDocument: {
      path: 'user/sponsor_requests/:sponsor_request_id/upload_signed_outcome_document', // PUT
      makeUrl: (sponsor_request_id: string): string =>
        `user/sponsor_requests/${sponsor_request_id}/upload_signed_outcome_document`, // PUT
    },
    deleteSponsorRequest: {
      path: 'user/sponsor_requests/:sponsor_request_id', // DELETE
      makeUrl: (sponsor_request_id: string): string =>
        `user/sponsor_requests/${sponsor_request_id}`, // DELETE
    },
    deleteSponsorshipProofs: {
      path: 'user/sponsor_requests/:sponsor_request_id/sponsorship_proofs/:sponsorship_proof_id', // DELETE
      makeUrl: (
        sponsor_request_id: number,
        sponsorship_proof_id: number
      ): string =>
        `user/sponsor_requests/${sponsor_request_id}/sponsorship_proofs/${sponsorship_proof_id}`, // DELETE
    },
  },
}

// ESTRA FORMS/ UGHETTO

export const ESTRA_FORMS_BASE_API_URL = `${process.env['API_ESTRA_FORMS_BASE_URL']}/ughetto`

export const estraFormsEndpoints = {
  forms: `forms`,
}
